import React from "react";
import { Base, UIBaseComponent } from "../Base";
import { BoxProps } from "./Box.types";

/** A plain element (a `div` by default); see `Base` for `as`, class lists and `srOnly`. */
export const Box: UIBaseComponent<BoxProps, HTMLDivElement> = React.forwardRef(
  (props, ref) => {
    return <Base {...props} ref={ref} />;
  }
);

Box.displayName = "Box";
